export enum GateKeeperEum {
    LockChecklist = 'Lock-Checklist',
    TaskSignOff = 'Task-Sign-Off',
    Both = 'Both',
    None = 'None ',
}
